import { render } from "./SwiperList.vue?vue&type=template&id=04620e25"
import script from "./SwiperList.vue?vue&type=script&lang=js"
export * from "./SwiperList.vue?vue&type=script&lang=js"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__